import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Steps } from "antd";
import { Provider } from "./MultiStepFormContext";
import Details from "./Details";
import TimeBudget from "./TimeBudget";
import UploadMedia from "./UploadMedia";
import './JobOnboarding.css';
import PopWindow from './Confirmation';
import api from '../../services/api';
import ErrorWindow from "../../components/ErrorWindow";
import SuccessPage from "./SuccessPage";
import Loader from '../../components/Loader/index'
import DashboardNavbar from "../../components/Navbar/navbar-dashboard";
import Footer from "../../components/Footer/footer";
import { jwtDecode } from "jwt-decode";
import showToast from "../../components/ShowToast";
import { API_BASE_URL } from '../../config';
import axios from "axios";
import '../../styles/home-user-landing-page.css';
import ProfessionDetail from "./ProfessionDetail";

const professionDetailsInitialState = {
  id: "",
  name: "",
  type: "",
  profession: [],
};

const detailsInitialState = {
  title: "",
  postcode: "",
  description: "",
};

const timeBudgetInitialState = {
  budgetAmount: null,
  budget: "",
  deadlineDate: null,
  deadline: "",
  siteVisit: "",
};

const mediaInitialState = [null, null, null, null];

const renderStep = (step) =>
{
  switch (step)
  {
    case 0:
      return <ProfessionDetail />;
    case 1:
      return <Details />;
    case 2:
      return <TimeBudget />;
    case 3:
      return <UploadMedia />;
    case 4:
      return <SuccessPage />;

    default:
      return null;
  }
};

const JobOnboarding = () =>
{
  const [ProfessionDetails, setProfessionDetails] = useState(professionDetailsInitialState);
  const [details, setDetails] = useState(detailsInitialState);
  const [timeBudget, setTimeBudget] = useState(timeBudgetInitialState);
  const [uploadedImages, setUploadedImages] = useState(mediaInitialState);
  const [currentStep, setCurrentStep] = useState(0);
  const [isPopup, setIsPopup] = useState(false);
  const [isErrorWindow, setIsErrorWindow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPublish, setIsPublish] = useState(true);

  const navigate = useNavigate();

  const next = async (isPublish) =>
  {
    if (currentStep == 3)
    {
      setIsLoading(true);
      const token = localStorage.getItem('token');
      if (!token)
      {
        showToast('error', 'Please Login to onboard jobs !!')
        return;
      }
      const decodeToken = jwtDecode(token);
      const homeUserId = decodeToken.nameid;
      const params = {
        userId: homeUserId,
        name: details?.title,
        profession: ProfessionDetails.profession,
        postcode: details?.postcode.toString(),
        country: "",
        description: details?.description,
        budgetAmount: timeBudget?.budgetAmount,
        budget: timeBudget?.budget,
        deadlineDate: timeBudget?.deadlineDate,
        deadline: timeBudget?.deadline,
        siteVisit: timeBudget?.siteVisit,
        image1: "",
        image2: "",
        image3: "",
        image4: "",
        jobStatus: "Open",
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        isPublish: isPublish,
        isNew: true
      }

      try
      {
        const response = await axios.post(`${API_BASE_URL}/api/Jobs/createjob`, params);
        console.log("createJob", response);
        let JOBID = response.data.job_id;
        await uploadImage(JOBID);
        // setIsLoading(false); 
        // setCurrentStep(3);
        setIsPopup(true);
      } catch (error)
      {
        setIsLoading(false);
        setIsErrorWindow(true);
      } finally
      {
        setIsLoading(false);
      }
      return;
    }
    setCurrentStep(currentStep + 1);
  };


  // Function to upload image
  const uploadImage = async (jobId) =>
  {
    try
    {
      if (!jobId || uploadedImages.length === 0)
      {
        console.error("Invalid jobId or no images selected.");
        return;
      }

      const formData = new FormData();

      for (const image of uploadedImages)
      {
        if (image && image.file)
        {
          formData.append("files", image.file);
        }
      }
      await api.post(`${API_BASE_URL}/api/Jobs/upload/${jobId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setIsLoading(false);
      setCurrentStep(3);

    } catch (error)
    {
      console.error("Error during job creation or image upload:", error);
    } finally
    {
      setIsLoading(false);
    }

  };


  const closePopup = () =>
  {
    setIsPopup(false);
    setProfessionDetails(professionDetailsInitialState);
    setDetails(detailsInitialState);
    setTimeBudget(timeBudgetInitialState);
    setUploadedImages(mediaInitialState);
    setCurrentStep(0);
    navigate("/JobsDashboard");
  };

  const closeErrorWindow = () =>
  {
    setIsErrorWindow(false);
  }

  // const openPopup = () => {
  //   setIsPopup(true);
  // }; 


  const prev = () => setCurrentStep(currentStep - 1);

  return (
    <>
      <DashboardNavbar prefix={''} />
      {" "}
      <div className="page_section">

        <section className="inner-page-banner text-center">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <h1>NEW JOB DETAILS</h1>
                {/* <p></p> */}
                <div className="banner-stepper four-stepper">
                  <div className={`step ${currentStep === 0 ? 'current' : (currentStep > 0 ? 'complete' : '')}`}>
                    <span className="step-icon">
                      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                        width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
                        preserveAspectRatio="xMidYMid meet">
                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                          fill="currentColor" stroke="none">
                          <path d="M1510 5109 c-14 -6 -36 -20 -48 -32 -46 -42 -56 -76 -62 -196 l-5
-113 -90 -32 c-49 -18 -118 -47 -152 -64 -34 -18 -68 -32 -74 -32 -7 0 -45 32
-85 70 -97 94 -156 117 -231 90 -37 -14 -291 -266 -309 -307 -33 -76 -11 -137
86 -237 38 -40 70 -78 70 -85 0 -6 -14 -40 -32 -74 -17 -34 -46 -102 -64 -152
l-32 -90 -113 -5 c-120 -6 -154 -16 -196 -62 -38 -40 -43 -73 -43 -262 0 -169
2 -185 22 -226 35 -69 71 -84 212 -90 l119 -5 28 -83 c15 -45 44 -116 63 -156
20 -41 36 -81 36 -88 0 -7 -32 -45 -71 -83 -99 -97 -118 -150 -84 -232 19 -44
245 -276 291 -298 37 -18 116 -20 147 -4 12 6 57 45 99 87 l77 76 98 -46 c54
-25 128 -55 164 -67 l67 -22 3 -118 c4 -107 6 -121 31 -158 44 -67 68 -73 296
-73 190 0 201 1 232 23 66 45 75 66 78 198 4 117 4 120 30 137 36 22 42 32 42
70 0 39 -30 72 -66 72 -38 0 -96 -36 -124 -77 -23 -33 -25 -48 -29 -155 l-3
-118 -167 2 -166 3 -5 122 c-5 117 -6 122 -36 160 -26 31 -48 44 -130 74 -55
20 -137 54 -184 77 -136 66 -174 59 -290 -53 -42 -41 -81 -75 -86 -75 -5 0
-61 52 -124 115 l-115 115 77 77 c90 93 98 106 98 173 0 38 -9 68 -37 123 -20
39 -53 118 -74 175 -57 159 -78 174 -249 182 l-115 5 0 165 0 165 125 6 c69 3
126 7 127 8 2 0 21 17 42 37 32 28 45 52 66 117 15 45 46 123 71 173 46 96 57
161 33 207 -7 12 -45 56 -85 98 -41 42 -74 81 -74 86 0 4 52 60 115 123 l115
114 42 -39 c23 -22 52 -50 65 -62 87 -88 150 -95 287 -29 50 24 128 56 173 71
65 21 89 34 117 66 20 21 37 40 37 42 1 1 5 58 8 127 l6 125 165 0 165 0 5
-115 c8 -171 23 -192 182 -249 57 -21 136 -54 175 -74 55 -28 85 -37 123 -37
67 0 80 8 172 97 l76 76 34 -27 c55 -41 105 -32 127 23 32 76 -89 166 -196
146 -28 -5 -56 -25 -118 -86 -45 -43 -87 -79 -94 -79 -7 0 -46 16 -88 36 -41
20 -112 49 -157 64 l-81 28 -5 118 c-6 141 -21 177 -90 212 -41 21 -57 22
-230 21 -102 0 -196 -5 -210 -10z"/>
                          <path d="M2808 4475 c-195 -37 -403 -153 -534 -298 -153 -170 -237 -375 -251
-608 l-6 -106 -33 -12 c-63 -23 -124 -115 -124 -186 0 -52 24 -102 69 -146
l48 -46 5 -99 c3 -55 12 -115 21 -135 21 -50 71 -96 128 -116 38 -14 51 -24
55 -43 35 -172 84 -282 174 -392 33 -40 86 -93 119 -118 l60 -45 -2 -94 -2
-94 -425 -83 c-456 -89 -561 -119 -698 -196 -110 -61 -227 -180 -275 -278 -72
-146 -72 -150 -72 -675 0 -461 0 -471 22 -517 30 -66 95 -132 156 -159 l52
-24 1735 0 1735 0 57 28 c66 33 112 80 145 154 l24 52 -3 493 -3 493 -29 75
c-64 167 -167 281 -337 373 -119 65 -227 94 -657 178 -229 44 -423 83 -429 85
-9 2 -13 31 -13 97 l0 94 39 27 c56 39 152 142 195 209 49 76 93 189 108 274
l12 70 42 11 c54 14 112 65 135 117 14 30 19 65 19 143 0 59 4 102 10 102 18
0 78 60 95 97 48 100 -13 255 -109 279 -22 5 -24 12 -30 110 -23 365 -222 668
-541 825 -152 74 -227 91 -435 95 -124 2 -197 -1 -252 -11z m144 -334 c3 -179
5 -201 22 -220 23 -26 81 -28 108 -4 16 15 18 35 18 221 l0 205 58 -7 c32 -4
80 -12 107 -19 l50 -12 3 -85 c3 -113 7 -125 42 -140 65 -27 110 18 110 110 0
22 4 40 8 40 16 0 97 -62 160 -124 149 -143 233 -328 248 -542 l7 -94 -862 0
-861 0 0 58 c0 259 141 523 358 671 l62 42 0 -61 c0 -51 4 -65 25 -85 30 -30
64 -32 99 -4 25 19 26 25 26 114 0 52 4 97 10 100 13 8 138 33 172 34 l27 1 3
-199z m1072 -834 c24 -18 24 -67 0 -84 -15 -11 -195 -13 -1003 -11 l-985 3
-15 26 c-13 24 -13 29 2 53 l17 26 983 0 c802 0 987 -2 1001 -13z m-104 -331
c0 -100 -6 -107 -93 -117 -78 -9 -92 -25 -100 -117 -15 -160 -77 -292 -187
-402 -240 -239 -572 -284 -870 -119 -104 58 -216 171 -264 268 -41 80 -76 202
-76 262 0 77 -33 109 -113 109 -23 0 -47 4 -54 8 -21 13 -33 61 -33 128 l0 64
895 0 895 0 0 -84z m-1136 -967 c170 -55 400 -45 569 26 15 6 17 -1 17 -89 0
-115 -11 -147 -75 -215 -48 -51 -160 -133 -230 -169 l-41 -20 -78 46 c-94 56
-210 160 -237 213 -15 30 -19 59 -19 140 0 92 2 101 18 94 9 -4 43 -16 76 -26z
m-215 -262 c39 -81 135 -179 249 -255 28 -19 52 -36 52 -37 0 -1 -27 -19 -61
-40 -51 -31 -67 -37 -100 -32 -22 3 -47 11 -55 18 -8 7 -54 69 -101 138 -47
69 -101 147 -120 172 l-33 47 73 15 c39 8 73 15 74 16 0 0 11 -18 22 -42z
m1079 8 c2 -2 -50 -82 -116 -177 -121 -175 -144 -198 -199 -198 -24 0 -127 52
-137 69 -3 4 28 31 69 60 95 68 185 162 218 228 l26 51 68 -14 c37 -8 69 -16
71 -19z m-1152 -397 c359 -518 398 -577 425 -644 22 -55 24 -75 27 -311 l4
-253 -556 0 -556 0 0 248 c0 501 -39 824 -139 1142 -11 35 -17 68 -13 72 5 5
130 32 278 62 148 30 270 54 271 55 0 0 117 -167 259 -371z m1608 312 c142
-28 262 -53 266 -55 4 -3 -6 -48 -21 -101 -62 -208 -116 -528 -121 -722 -3
-88 -2 -95 21 -113 30 -24 76 -24 100 0 14 14 21 40 25 98 14 169 38 353 61
461 36 170 78 312 91 312 23 0 163 -101 200 -143 19 -23 47 -63 60 -89 52
-101 54 -128 54 -611 0 -439 0 -450 -21 -484 -39 -63 -75 -73 -274 -73 l-175
0 0 155 c0 154 0 156 -26 182 -20 20 -31 24 -57 19 -61 -12 -67 -30 -67 -202
l0 -154 -560 0 -560 0 0 193 c0 217 10 305 43 387 14 33 153 244 327 496 364
527 347 504 363 499 6 -2 129 -27 271 -55z m-2531 -226 c82 -294 106 -494 114
-942 l6 -353 -189 3 c-179 3 -191 4 -222 26 -68 49 -67 38 -67 532 0 404 2
451 19 513 23 83 76 168 142 226 54 48 143 103 159 98 6 -2 22 -48 38 -103z
m1566 -137 c58 -35 116 -68 128 -73 20 -9 15 -19 -103 -188 -68 -98 -124 -182
-124 -187 0 -19 -17 -8 -35 24 -10 17 -68 101 -127 186 l-108 155 43 22 c23
11 80 44 127 73 47 28 87 51 89 51 2 0 51 -28 110 -63z"/>
                          <path d="M1648 4228 c-231 -22 -442 -165 -548 -369 -56 -107 -80 -208 -80
-332 0 -124 19 -205 73 -317 34 -70 57 -101 132 -175 135 -136 275 -200 460
-212 82 -5 92 -3 118 17 20 16 27 30 27 56 0 53 -28 74 -97 74 -153 1 -290 58
-398 165 -115 114 -165 234 -165 395 0 95 18 176 54 248 72 141 212 252 371
291 76 19 211 15 286 -9 81 -25 85 -25 114 5 31 30 33 77 5 105 -42 42 -220
71 -352 58z"/>
                        </g>
                      </svg>
                    </span>
                    <span className="step-text">Profession for Job</span>
                  </div>
                  <div className={`step ${currentStep === 1 ? 'current' : (currentStep > 1 ? 'complete' : '')}`}>
                    <span className="step-icon">
                      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                        width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
                        preserveAspectRatio="xMidYMid meet">

                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                          fill="currentColor" stroke="none">
                          <path d="M3380 5034 c-383 -48 -695 -203 -950 -471 -291 -306 -440 -723 -409
-1148 14 -194 59 -362 144 -542 51 -108 81 -143 125 -143 36 0 80 38 80 70 0
11 -20 60 -44 108 -85 170 -130 329 -145 508 -35 441 141 863 475 1143 437
365 1043 423 1532 147 l74 -41 -36 -6 c-51 -8 -76 -34 -76 -80 0 -29 6 -43 28
-59 26 -22 32 -22 182 -16 167 8 193 15 204 61 7 27 -53 265 -80 316 -36 71
-144 41 -144 -40 0 -18 -3 -31 -7 -29 -5 2 -69 33 -143 70 -211 105 -384 147
-630 153 -80 2 -161 1 -180 -1z"/>
                          <path d="M948 4760 c-13 -8 -348 -389 -570 -648 -34 -40 -38 -92 -8 -122 17
-17 33 -20 125 -20 l105 0 0 -449 c0 -247 3 -457 6 -466 16 -41 48 -45 379
-45 322 0 344 2 372 39 9 12 12 129 13 469 l0 452 105 0 c92 0 108 3 125 20
30 30 26 82 -8 122 -240 281 -558 640 -572 648 -23 13 -50 12 -72 0z m227
-410 l187 -215 -53 -7 c-40 -5 -59 -13 -76 -33 l-23 -26 0 -450 0 -449 -225 0
-225 0 0 449 0 450 -23 26 c-17 20 -36 28 -75 33 l-53 7 188 217 c103 119 188
216 189 215 1 -1 86 -99 189 -217z"/>
                          <path d="M3353 4555 c-12 -8 -34 -47 -49 -86 -15 -39 -35 -73 -44 -76 -8 -3
-50 -20 -93 -38 l-79 -33 -70 29 c-48 21 -78 28 -97 24 -18 -4 -68 -46 -135
-114 -122 -124 -124 -132 -79 -233 22 -50 25 -64 16 -87 -6 -14 -24 -57 -40
-95 l-29 -69 -65 -24 c-99 -37 -99 -37 -99 -227 0 -189 -1 -187 108 -226 50
-18 64 -28 69 -49 3 -14 19 -56 36 -94 l30 -67 -27 -63 c-43 -103 -42 -106 87
-235 128 -128 132 -129 234 -86 l63 27 57 -25 c32 -14 74 -31 94 -37 33 -11
39 -18 59 -74 39 -108 37 -107 226 -107 190 0 190 0 227 99 l24 65 69 29 c38
16 81 34 95 40 23 9 37 6 87 -16 101 -45 109 -43 233 79 68 67 110 117 114
135 4 19 -3 49 -24 97 l-29 70 33 79 c18 43 35 85 38 93 3 9 37 29 76 44 39
15 78 37 86 49 12 17 15 55 15 173 0 180 -3 186 -108 227 -65 26 -70 30 -82
70 -7 23 -23 64 -37 91 l-24 48 32 73 c20 47 30 81 26 97 -9 34 -229 248 -255
248 -12 0 -53 -14 -91 -31 l-69 -31 -48 25 c-27 14 -68 30 -91 37 -40 12 -44
17 -70 82 -41 105 -47 108 -227 108 -118 0 -156 -3 -173 -15z m263 -182 c38
-100 44 -106 126 -134 43 -14 105 -40 138 -57 33 -18 68 -32 78 -32 9 0 45 12
80 27 l63 27 51 -52 52 -51 -27 -63 c-15 -35 -27 -71 -27 -80 0 -10 14 -45 32
-78 17 -33 43 -95 57 -138 28 -82 34 -88 134 -126 l37 -15 0 -74 0 -75 -59
-22 c-74 -27 -85 -40 -115 -126 -13 -38 -37 -97 -55 -131 -17 -34 -31 -70 -31
-79 0 -9 12 -43 27 -76 l26 -59 -53 -54 -53 -53 -55 24 c-69 30 -104 30 -156
0 -23 -13 -77 -36 -121 -51 -98 -34 -116 -49 -140 -120 l-19 -56 -78 3 -79 3
-24 60 c-29 70 -39 79 -113 101 -31 8 -86 31 -124 50 -81 41 -106 42 -177 8
l-55 -25 -53 54 -54 53 25 55 c34 71 33 96 -8 177 -19 38 -42 93 -50 124 -22
74 -31 84 -101 113 l-60 24 -3 79 -3 78 56 19 c71 24 86 42 120 140 15 44 38
98 51 121 30 52 30 87 0 156 l-24 55 53 53 54 53 59 -26 c33 -15 67 -27 76
-27 9 0 45 14 79 31 34 18 93 42 131 55 86 30 99 41 126 115 l22 59 75 0 74 0
15 -37z"/>
                          <path d="M3383 4080 c-111 -29 -175 -66 -265 -156 -101 -100 -160 -243 -160
-388 -1 -165 52 -298 166 -410 114 -115 251 -171 411 -170 256 3 481 179 545
429 36 140 23 259 -42 394 -116 242 -393 370 -655 301z m237 -151 c230 -53
370 -295 300 -521 -91 -296 -450 -390 -675 -177 -158 150 -172 400 -31 565 96
112 261 167 406 133z"/>
                          <path d="M4733 4320 c-26 -11 -43 -40 -43 -72 0 -14 22 -69 49 -124 236 -478
169 -1044 -171 -1458 -210 -254 -509 -423 -843 -476 -100 -16 -306 -14 -421 5
-129 21 -283 73 -406 137 -96 50 -109 67 -51 68 26 0 63 44 63 76 0 12 -10 35
-23 49 l-23 27 -146 -1 c-194 -2 -228 -15 -228 -88 1 -39 76 -293 92 -309 7
-8 28 -16 45 -20 27 -5 37 -1 64 25 26 26 30 37 25 61 -3 17 -4 30 -2 30 1 0
38 -20 82 -45 178 -102 406 -169 620 -183 354 -24 663 59 962 255 119 78 319
279 401 402 118 179 191 355 233 564 18 89 22 147 23 282 0 194 -17 306 -70
471 -34 102 -122 291 -147 311 -20 17 -60 23 -85 13z"/>
                          <path d="M1265 2616 c-138 -33 -244 -88 -340 -178 -215 -200 -286 -494 -186
-768 48 -130 135 -247 244 -327 l50 -37 -64 -22 c-246 -83 -500 -273 -648
-484 -109 -154 -195 -359 -226 -534 -20 -118 -19 -133 10 -161 l24 -25 1273 0
c1152 0 1276 2 1296 16 38 26 43 55 27 152 -80 468 -404 859 -854 1028 l-83
32 58 43 c260 197 348 572 205 874 -85 180 -263 328 -456 380 -84 23 -255 28
-330 11z m279 -166 c107 -27 169 -63 251 -145 113 -112 165 -236 165 -390 0
-151 -52 -278 -160 -386 -81 -81 -154 -123 -262 -151 -276 -69 -559 88 -655
364 -21 60 -25 92 -25 173 0 120 23 202 81 292 135 209 369 304 605 243z m21
-1260 c444 -63 806 -360 953 -780 16 -47 33 -104 37 -128 l7 -42 -1155 0
-1155 0 13 58 c122 520 593 896 1130 901 55 0 132 -4 170 -9z"/>
                          <path d="M4055 1605 c-23 -22 -25 -31 -25 -124 l0 -100 -455 -3 -454 -3 -23
-23 -23 -23 0 -339 c0 -312 1 -341 18 -357 16 -17 53 -18 475 -23 l457 -5 5
-108 c5 -99 7 -111 29 -128 26 -22 57 -24 87 -6 53 31 675 584 680 604 4 13 3
34 0 47 -3 14 -133 134 -347 320 -370 321 -373 323 -424 271z m373 -440 c106
-92 191 -172 189 -178 -2 -6 -97 -92 -213 -192 l-209 -182 -5 53 c-4 38 -12
60 -28 76 l-23 23 -454 3 -455 3 2 222 3 222 457 5 c522 6 488 -1 496 95 l5
56 21 -19 c11 -10 108 -94 214 -187z"/>
                        </g>
                      </svg>
                    </span>
                    <span className="step-text">New Job Details</span>
                  </div>
                  <div className={`step ${currentStep === 2 ? 'current' : (currentStep > 2 ? 'complete' : '')}`}>
                    <span className="step-icon">
                      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                        width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
                        preserveAspectRatio="xMidYMid meet">

                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                          fill="currentColor" stroke="none">
                          <path d="M787 5070 c-323 -58 -585 -282 -685 -584 -171 -515 155 -1050 693
-1137 92 -14 254 -7 345 17 78 20 211 80 275 124 179 123 317 331 361 543 18
83 20 257 4 337 -37 195 -154 390 -310 517 -81 66 -220 136 -325 164 -90 23
-279 34 -358 19z m281 -146 c236 -49 423 -199 523 -420 42 -93 60 -184 60
-299 -1 -201 -68 -362 -211 -505 -96 -96 -178 -148 -295 -187 -71 -24 -95 -27
-220 -27 -124 0 -149 3 -217 26 -123 41 -204 92 -298 187 -98 98 -155 196
-191 327 -30 106 -30 257 0 367 99 373 475 608 849 531z"/>
                          <path d="M881 4743 c-16 -13 -24 -33 -28 -74 -5 -55 -6 -56 -47 -67 -72 -19
-130 -64 -160 -123 -33 -67 -33 -111 0 -177 40 -80 113 -122 284 -162 82 -19
148 -55 156 -85 19 -76 -48 -121 -170 -113 -81 5 -127 25 -172 74 -37 39 -74
44 -104 14 -58 -58 32 -177 161 -211 l47 -13 4 -53 c7 -83 58 -118 116 -77 18
12 22 25 22 69 0 47 3 54 23 60 76 20 102 32 138 64 51 43 78 100 79 164 0 64
-19 104 -69 150 -50 45 -103 70 -214 98 -112 28 -165 53 -179 83 -25 56 30
104 131 113 79 7 137 -11 183 -58 48 -48 86 -52 117 -13 27 35 26 51 -4 96
-28 41 -93 84 -158 103 l-42 12 -3 56 c-2 45 -8 60 -25 72 -28 20 -60 19 -86
-2z"/>
                          <path d="M2109 4674 c-134 -97 -149 -112 -149 -144 0 -37 10 -47 136 -139 120
-87 147 -96 182 -58 29 31 28 65 -5 99 l-27 28 677 0 677 0 0 -138 c0 -160 8
-182 66 -182 21 0 42 8 54 20 19 19 20 33 20 205 0 184 0 186 -25 210 l-24 25
-722 0 -722 0 27 25 c15 14 26 35 26 50 0 30 -41 75 -68 75 -11 0 -66 -34
-123 -76z"/>
                          <path d="M3363 3948 c-12 -14 -25 -51 -33 -93 -7 -38 -16 -76 -20 -84 -4 -7
-58 -34 -121 -60 l-114 -47 -74 48 c-40 26 -85 48 -99 48 -20 0 -71 -45 -229
-202 -168 -168 -203 -207 -203 -230 0 -17 18 -56 45 -96 25 -37 45 -73 45 -80
0 -29 -93 -231 -108 -236 -10 -3 -46 -10 -82 -17 -115 -21 -110 -5 -110 -339
0 -334 -5 -318 110 -339 36 -7 72 -14 82 -17 15 -5 108 -207 108 -236 0 -7
-20 -43 -45 -80 -27 -40 -45 -79 -45 -96 0 -23 35 -62 203 -230 158 -157 209
-202 229 -202 14 0 59 22 99 48 l74 49 114 -47 c63 -26 117 -54 121 -61 4 -8
13 -45 20 -84 22 -121 4 -115 341 -115 l288 0 19 25 c12 14 26 57 33 98 6 39
16 76 20 81 5 5 59 30 121 56 l113 47 72 -49 c43 -28 83 -48 100 -48 40 0 433
392 433 432 0 15 -21 57 -49 99 -50 73 -50 73 -35 108 9 20 29 70 46 111 17
41 37 80 44 86 7 6 46 16 85 24 51 9 79 19 96 36 l23 23 0 281 0 281 -23 23
c-17 17 -45 27 -96 36 -39 8 -78 18 -85 24 -7 6 -27 45 -44 86 -17 41 -37 91
-46 111 -15 35 -15 35 35 108 28 42 49 84 49 99 0 40 -393 432 -433 432 -17 0
-57 -20 -100 -48 l-72 -49 -113 47 c-62 26 -116 51 -121 56 -4 5 -14 42 -20
81 -7 41 -21 84 -33 98 l-19 25 -288 0 c-285 0 -288 0 -308 -22z m511 -135 c2
-10 10 -44 16 -76 7 -32 20 -66 30 -74 10 -9 92 -47 183 -84 185 -77 177 -77
269 -14 l53 35 142 -142 c78 -78 139 -146 135 -152 -3 -6 -23 -38 -44 -70 -21
-33 -38 -63 -38 -68 0 -29 147 -361 163 -370 10 -5 49 -15 85 -22 l67 -12 0
-204 0 -204 -67 -12 c-36 -7 -75 -17 -85 -22 -16 -9 -163 -341 -163 -370 0 -5
17 -35 38 -68 21 -32 41 -64 44 -70 4 -6 -57 -74 -135 -152 l-142 -142 -53 35
c-92 63 -83 63 -275 -16 -95 -39 -177 -78 -184 -86 -7 -9 -17 -41 -23 -72 -6
-31 -14 -64 -16 -74 -5 -16 -21 -17 -207 -15 l-201 3 -14 70 c-9 46 -21 77
-35 91 -19 18 -333 154 -356 154 -4 0 -39 -20 -77 -45 l-69 -44 -144 143 -144
144 42 58 c25 35 41 68 41 86 0 37 -117 324 -144 354 -15 16 -43 27 -91 36
l-70 14 0 204 0 203 70 14 c48 10 76 21 91 37 27 30 144 317 144 354 0 18 -16
51 -41 86 l-42 58 144 144 144 144 53 -35 c92 -63 84 -63 265 12 89 37 172 75
184 86 14 12 25 41 33 85 7 37 15 70 17 75 2 4 94 7 203 7 181 0 199 -2 204
-17z"/>
                          <path d="M3476 3464 c-354 -79 -638 -366 -710 -716 -20 -99 -21 -277 0 -376
35 -172 136 -355 262 -474 184 -173 391 -257 633 -258 168 0 287 28 434 103
219 114 386 316 461 562 26 83 28 103 28 255 0 152 -2 172 -28 255 -57 185
-168 350 -314 467 -85 68 -240 146 -342 173 -93 24 -333 30 -424 9z m149 -149
c-33 -32 -35 -105 -5 -135 27 -27 74 -26 100 2 30 32 28 101 -5 133 l-24 25
43 0 c59 0 188 -34 265 -70 224 -105 396 -326 440 -564 14 -74 14 -152 1 -119
-12 29 -40 43 -89 43 -50 0 -81 -27 -81 -70 0 -43 31 -70 81 -70 49 0 77 14
89 43 15 37 12 -59 -4 -134 -54 -251 -237 -469 -476 -566 -70 -28 -178 -53
-232 -53 l-37 0 24 25 c33 32 35 101 5 133 -26 28 -73 29 -100 2 -30 -30 -28
-103 5 -135 l24 -25 -43 0 c-70 0 -195 37 -296 87 -80 40 -110 62 -191 143
-86 85 -102 107 -147 200 -51 106 -82 215 -82 289 l0 40 25 -24 c18 -19 35
-25 70 -25 54 0 85 25 85 70 0 45 -31 70 -85 70 -35 0 -52 -6 -70 -25 l-25
-24 0 40 c0 74 31 183 82 289 45 93 61 115 147 200 81 81 111 103 191 143 104
52 218 86 292 86 l47 1 -24 -25z"/>
                          <path d="M3122 3107 c-34 -36 -28 -69 18 -111 47 -42 72 -45 105 -11 35 34 31
61 -14 106 -45 45 -77 50 -109 16z"/>
                          <path d="M4107 3092 c-43 -44 -47 -73 -12 -107 34 -35 61 -31 106 14 45 45 49
72 14 106 -34 35 -65 32 -108 -13z"/>
                          <path d="M3626 3029 l-26 -20 0 -212 0 -211 -130 -131 c-82 -83 -130 -139
-130 -152 0 -29 30 -61 63 -69 27 -6 40 5 183 148 l154 154 0 232 0 233 -25
24 c-30 30 -54 31 -89 4z"/>
                          <path d="M3140 2124 c-47 -43 -52 -79 -17 -112 34 -32 64 -27 108 17 45 45 49
72 14 106 -33 34 -58 31 -105 -11z"/>
                          <path d="M4095 2135 c-35 -34 -32 -65 13 -108 44 -43 73 -47 107 -12 35 34 31
61 -14 106 -45 45 -72 49 -106 14z"/>
                          <path d="M2005 3275 c-14 -13 -25 -33 -25 -45 0 -11 11 -32 25 -45 23 -24 30
-25 150 -25 120 0 127 1 150 25 30 30 31 54 4 89 -20 26 -22 26 -150 26 -125
0 -131 -1 -154 -25z"/>
                          <path d="M874 3139 c-18 -20 -19 -46 -24 -458 -3 -240 -9 -429 -13 -419 -5 9
-22 22 -38 29 -26 10 -34 9 -57 -8 -50 -37 -43 -70 43 -187 95 -130 104 -138
147 -134 29 3 43 16 121 118 75 99 87 120 85 149 -2 23 -11 40 -30 54 -23 17
-31 18 -57 8 -16 -7 -32 -19 -35 -27 -3 -8 -10 -14 -16 -14 -7 0 -10 144 -10
438 0 413 -1 440 -18 455 -26 24 -75 21 -98 -4z"/>
                          <path d="M1840 2963 c-32 -12 -50 -37 -50 -68 0 -58 20 -65 173 -65 129 0 137
1 151 22 22 31 20 71 -5 94 -18 16 -39 19 -138 21 -64 1 -123 0 -131 -4z"/>
                          <path d="M1612 2607 c-28 -30 -28 -68 1 -95 21 -20 34 -22 149 -22 145 0 171
11 171 70 0 59 -26 70 -172 70 -120 0 -129 -1 -149 -23z"/>
                          <path d="M1807 2272 c-24 -26 -21 -75 4 -98 18 -17 37 -19 149 -19 112 0 131
2 149 19 25 23 27 63 5 94 -14 21 -22 22 -153 22 -121 0 -140 -2 -154 -18z"/>
                          <path d="M2005 1935 c-14 -13 -25 -33 -25 -45 0 -11 11 -32 25 -45 23 -24 29
-25 154 -25 128 0 130 0 150 26 27 35 26 59 -4 89 -23 24 -30 25 -150 25 -120
0 -127 -1 -150 -25z"/>
                          <path d="M855 1699 c-140 -20 -275 -121 -343 -258 -37 -74 -37 -77 -37 -195 0
-115 2 -124 32 -189 18 -37 55 -91 83 -121 52 -55 58 -66 37 -66 -20 0 -152
-66 -205 -102 -69 -47 -168 -144 -218 -214 -82 -114 -145 -275 -160 -406 -6
-53 -4 -61 16 -83 l23 -25 839 0 839 0 24 25 c29 28 30 39 11 137 -38 194
-132 360 -278 493 -68 61 -185 135 -258 162 -25 9 -47 18 -49 19 -2 2 20 29
49 61 30 32 67 87 84 123 29 61 30 72 31 185 0 115 -1 123 -32 188 -62 131
-208 246 -331 262 -26 3 -58 7 -72 9 -14 1 -52 -1 -85 -5z m166 -150 c48 -12
121 -62 154 -105 63 -83 83 -208 48 -310 -24 -70 -120 -165 -191 -188 -115
-39 -247 -8 -331 75 -67 67 -86 118 -86 229 0 86 3 100 29 148 76 136 214 192
377 151z m85 -789 c119 -30 233 -91 321 -174 113 -105 184 -225 228 -383 l6
-23 -735 0 c-405 0 -736 2 -736 4 0 2 10 35 21 72 77 248 276 438 529 503 104
27 261 28 366 1z"/>
                          <path d="M3628 1008 c-34 -27 -178 -233 -178 -256 0 -29 42 -72 70 -72 12 0
35 13 51 29 l29 29 0 -184 0 -184 -743 0 c-708 0 -745 -1 -760 -18 -24 -26
-21 -75 4 -98 20 -18 48 -19 811 -19 l790 0 19 24 c17 21 19 42 19 248 l0 225
32 -27 c36 -30 71 -28 101 7 31 37 26 48 -76 188 -80 109 -91 120 -127 120
-14 0 -33 -6 -42 -12z"/>
                        </g>
                      </svg>
                    </span>
                    <span className="step-text">Time and Budget</span>
                  </div>
                  <div className={`step ${currentStep === 3 ? 'current' : (currentStep > 3 ? 'complete' : '')}`}>
                    <span className="step-icon">
                      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                        width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
                        preserveAspectRatio="xMidYMid meet">

                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                          fill="currentColor" stroke="none">
                          <path d="M685 5108 c-27 -5 -87 -27 -133 -49 -150 -72 -259 -208 -302 -374
-20 -77 -20 -112 -20 -1770 0 -1658 0 -1693 20 -1770 49 -193 183 -336 380
-407 l65 -23 735 -3 735 -3 52 -78 c151 -224 399 -421 661 -525 611 -244 1316
-46 1712 482 389 519 395 1221 13 1743 -196 270 -515 484 -830 559 l-53 12 0
491 c-1 361 -4 499 -13 519 -17 38 -1113 1187 -1144 1199 -32 12 -1811 10
-1878 -3z m1735 -588 c6 -413 7 -422 62 -517 56 -99 143 -170 264 -215 55 -20
81 -22 412 -26 l352 -4 0 -413 0 -413 -115 -1 c-318 -2 -655 -123 -896 -322
l-46 -38 -702 -3 -703 -3 -29 -33 c-57 -64 -29 -153 56 -172 22 -5 293 -10
603 -10 309 0 562 -2 562 -5 0 -2 -26 -44 -57 -92 -31 -48 -72 -121 -90 -161
l-34 -72 -505 0 -506 0 -29 -29 c-41 -41 -41 -98 0 -143 l29 -33 472 -3 472
-3 -5 -22 c-23 -94 -31 -174 -31 -312 1 -201 19 -310 91 -528 5 -17 -27 -17
-668 -15 l-674 3 -55 27 c-109 54 -180 151 -200 275 -13 78 -13 3278 0 3356
26 160 141 281 292 306 29 5 418 8 863 7 l810 -1 5 -385z m621 -205 l313 -330
-257 -3 c-244 -2 -260 -1 -307 19 -27 12 -67 41 -89 64 -65 70 -71 107 -71
414 l0 266 49 -50 c27 -28 190 -198 362 -380z m530 -1606 c294 -38 550 -167
754 -380 457 -478 461 -1230 9 -1719 -56 -60 -177 -159 -259 -212 -304 -194
-735 -237 -1087 -107 -373 137 -661 447 -772 830 -38 134 -49 234 -43 398 12
317 124 582 342 810 275 289 669 430 1056 380z"/>
                          <path d="M1021 3069 c-55 -55 -37 -142 36 -170 14 -5 258 -9 579 -9 611 0 597
-1 630 61 22 43 11 91 -27 123 l-31 26 -578 0 -578 0 -31 -31z"/>
                          <path d="M3373 2273 c-29 -16 -628 -649 -667 -705 -9 -12 -16 -40 -16 -61 0
-77 83 -122 157 -85 12 6 120 116 240 245 l218 234 5 -593 c4 -456 8 -598 18
-615 15 -26 61 -53 92 -53 31 0 77 27 92 53 10 17 14 159 18 616 l5 593 220
-237 c134 -146 232 -243 252 -251 85 -36 175 62 130 143 -12 21 -587 642 -644
694 -38 36 -80 44 -120 22z"/>
                        </g>
                      </svg>
                    </span>
                    <span className="step-text">Upload media for Job</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="right_panel">
          <Provider
            value={{
              ProfessionDetails,
              setProfessionDetails,
              details,
              setDetails,
              timeBudget,
              setTimeBudget,
              uploadedImages,
              setUploadedImages,
              isPopup,
              setIsPopup,
              next,
              prev,
              isPublish,
              setIsPublish
            }}
          >
            <Steps current={currentStep}></Steps>
            <section class="onboarding-form">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12">
                    {renderStep(currentStep)}
                  </div>
                </div>
              </div>
            </section>
          </Provider>
        </div>
      </div>

      {isPopup && (
        <PopWindow onClose={closePopup} details={details} timeBudget={timeBudget} uploadedImages={uploadedImages} />
      )}
      {!isPopup && (
        <></>
      )}

      {isErrorWindow && (
        <ErrorWindow onClose={closeErrorWindow} />
      )}
      {!isErrorWindow && (
        <></>
      )}

      {isLoading &&
        <Loader />
      }
      {!isLoading && (
        <></>
      )}
      <Footer />
    </>
  );
};

export default JobOnboarding;
